// extracted by mini-css-extract-plugin
export default {"page":"StateTripsList_page__267L5","wrapper":"StateTripsList_wrapper__6367u","list":"StateTripsList_list__+jRer","listWrapper":"StateTripsList_listWrapper__uvLrD"};